import { StyleSheet } from "react-native";
import { theme } from "@clearabee/ui-library-native";
export const styles = StyleSheet.create({
  topPanel: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing.small,
    marginBottom: theme.spacing.medium,
  },
  welcomeWrapper: {
    flexDirection: "column",
    alignItems: "center",
  },
  subheading: {
    textTransform: "uppercase",
    marginBottom: theme.spacing.xsmall2,
  },
  activeJobPanel: {
    marginBottom: theme.spacing.small,
    paddingVertical: theme.spacing.small,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    overflow: "visible",
  },
  activeJobPill: {
    position: "absolute",
    top: -theme.spacing.small,
    right: theme.spacing.small,
  },
});
